import { render, staticRenderFns } from "./h5Content.vue?vue&type=template&id=15350981&scoped=true"
import script from "./h5Content.vue?vue&type=script&lang=js"
export * from "./h5Content.vue?vue&type=script&lang=js"
import style0 from "./h5Content.vue?vue&type=style&index=0&id=15350981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15350981",
  null
  
)

export default component.exports